import {AdminLogsState} from './states/admin-logs.state';

export const adminLogs = [
    AdminLogsState
];
